import React, { useRef, useState, useEffect } from 'react';
// import {
//   MdPlayArrow,
//   MdPause,
// } from 'react-icons/md';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faForward, faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
// import { CgSpinner } from 'react-icons/cg';
import IconButton from './IconButton';
import AudioProgressBar from './AudioProgressBar';
// import VolumeInput from './VolumeInput';
import styles from '../Styles/Pages.module.scss';

function formatDurationDisplay(duration) {
  const min = Math.floor(duration / 60);
  const sec = Math.floor(duration - min * 60);

  const formatted = [min, sec].map((n) => (n < 10 ? '0' + n : n)).join(':');

  return formatted;
}

export default function AudioPlayer({
  currentSong,
  songIndex,
  songCount,
  onNext,
  onPrev,
}) {
  const audioRef = useRef(null);

  const [isReady, setIsReady] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currrentProgress, setCurrrentProgress] = useState(0);
  const [buffered, setBuffered] = useState(0);
  const [volume, setVolume] = useState(0.2);
  const [isPlaying, setIsPlaying] = useState(false);

  const durationDisplay = formatDurationDisplay(duration);
  const elapsedDisplay = formatDurationDisplay(currrentProgress);

  useEffect(() => {
    audioRef.current?.pause();

    const timeout = setTimeout(() => {
      audioRef.current?.play();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [songIndex]);

  const handleNext = () => {
    onNext();
  };

  const handlePrev = () => {
    onPrev();
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(false);
    } else {
      audioRef.current?.play();
      setIsPlaying(true);
    }
  };

  const handleBufferProgress = (e) => {
    const audio = e.currentTarget;
    const dur = audio.duration;
    if (dur > 0) {
      for (let i = 0; i < audio.buffered.length; i++) {
        if (
          audio.buffered.start(audio.buffered.length - 1 - i) <
          audio.currentTime
        ) {
          const bufferedLength = audio.buffered.end(
            audio.buffered.length - 1 - i
          );
          setBuffered(bufferedLength);
          break;
        }
      }
    }
  };

  // const handleMuteUnmute = () => {
  //   if (!audioRef.current) return;

  //   if (audioRef.current.volume !== 0) {
  //     audioRef.current.volume = 0;
  //   } else {
  //     audioRef.current.volume = 1;
  //   }
  // };

  // const handleVolumeChange = (volumeValue) => {
  //   if (!audioRef.current) return;
  //   audioRef.current.volume = volumeValue;
  //   setVolume(volumeValue);
  // };

  return (
    <div className={styles.twelth}>
      {currentSong && (
        <audio
          ref={audioRef}
          preload="metadata"
          onDurationChange={(e) => setDuration(e.currentTarget.duration)}
          onPlaying={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onEnded={handleNext}
          onCanPlay={(e) => {
            e.currentTarget.volume = volume;
            setIsReady(true);
          }}
          onTimeUpdate={(e) => {
            setCurrrentProgress(e.currentTarget.currentTime);
            handleBufferProgress(e);
          }}
          onProgress={handleBufferProgress}
          onVolumeChange={(e) => setVolume(e.currentTarget.volume)}
        >
          <source type="audio/mpeg" src={currentSong.source} />
        </audio>
      )}
      <AudioProgressBar
        duration={duration}
        currentProgress={currrentProgress}
        buffered={buffered}
        onChange={(e) => {
          if (!audioRef.current) return;

          audioRef.current.currentTime = e.currentTarget.valueAsNumber;

          setCurrrentProgress(e.currentTarget.valueAsNumber);
        }}
      />

      {/* <div className={styles.thirteenth}>
        <div className={styles.fourteenth}>
          <p className={styles.fifteenth}>
            {currentSong?.title ?? 'Select a song'}
          </p>
        </div>
      </div> */}
      <div className={styles.seventeenth}>
        <span className={styles.sixteenth}>
          {elapsedDisplay} / {durationDisplay}
        </span>
        <div className={styles.eighteenth}>
          <IconButton
            onClick={handlePrev}
            disabled={songIndex === 0}
            aria-label="go to previous"
            intent="secondary"
          >
            <FontAwesomeIcon icon={faForward} size="lg" className="fa-flip-horizontal" />
          </IconButton>
          <IconButton
            disabled={!isReady}
            onClick={togglePlayPause}
            aria-label={isPlaying ? 'Pause' : 'Play'}
            size="lg"
          >
            {!isReady && currentSong ? (
              // <CgSpinner size={24} className={styles.ninteenth} />
              <FontAwesomeIcon icon={faPause} size="2x" />
            ) : isPlaying ? (
              <FontAwesomeIcon icon={faPause} size="2x" />
            ) : (
              <FontAwesomeIcon icon={faPlay} size="2x" />
            )}
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={songIndex === songCount - 1}
            aria-label="go to next"
            intent="secondary"
          >
            <FontAwesomeIcon icon={faForward} size="lg" />
          </IconButton>
        </div>

        {/* <div className={styles.twenty}>
          <IconButton
            intent="secondary"
            size="sm"
            onClick={handleMuteUnmute}
            aria-label={volume === 0 ? 'unmute' : 'mute'}
          >
            {volume === 0 ? (
              <MdVolumeOff size={20} />
            ) : (
              <MdVolumeUp size={20} />
            )}
          </IconButton>
          <VolumeInput volume={volume} onVolumeChange={handleVolumeChange} />
        </div> */}
      </div>
    </div>
  );
}
